import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/utils/config/config.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Injectable({
  providedIn: 'root'
})
export class TipoAceiteService {
  controller: string = "tipo-aceite/";

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService,
  ) { }

  index_select(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'ver-select', this.sesion.headers);
  }

  insert(usuario: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'crear', usuario, this.sesion.headers);
  }
}